import request from "@/utils/request";
// 最新交易所数据
export function getOptions(params) {
  return request({
    url: "/option/" + params,
    method: "get",
  });
}
export function getNewsSave(data) {
  return request({
    url: "/check/newsInfo/save",
    method: "post",
    data,
  });
}
//专家信息以及扩展信息保存
export function getExpertSave(data) {
  return request({
    url: "/check/expertInfo/save",
    method: "post",
    data,
  });
}
// 专家访谈保存
export function saveInterview(data) {
  return request({
    url: "/check/expertInfo/saveInterview",
    method: "post",
    data,
  });
}
